export default __webpack_public_path__ + "static/media/1.780a9424.png";